module.exports = require('../manifest.json').version



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 12
// module chunks = 0